var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 1.25C15.8896 1.25 16.4492 1.80964 16.4492 2.5V15.9441C16.4492 15.9441 15.1992 13.75 10.1992 13.75C5.19922 13.75 3.94922 15.9443 3.94922 15.9443V2.5C3.94922 1.80964 4.50886 1.25 5.19922 1.25H15.1992ZM5.19922 0C3.81851 0 2.69922 1.11929 2.69922 2.5V17.5C2.69922 18.8807 3.81851 20 5.19922 20H15.1992C16.5799 20 17.6992 18.8807 17.6992 17.5V2.5C17.6992 1.11929 16.5799 0 15.1992 0H5.19922Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 12.5C12.2703 12.5 13.9492 10.8211 13.9492 8.75C13.9492 6.67893 12.2703 5 10.1992 5C8.12815 5 6.44922 6.67893 6.44922 8.75C6.44922 10.8211 8.12815 12.5 10.1992 12.5Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralAttendance);
export default __webpack_public_path__ + "static/media/general-attendance.e35350839cee25b6160287abe456cd8a.svg";
export { ForwardRef as ReactComponent };